import * as types from "./types";

export const dash_lc = () => ({
  type: types.DASH_LC,
});
